/* eslint-disable no-alert */
<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 09:31:46
 * @LastEditTime: 2020-06-16 14:47:30
 * @Description: 考试试卷详情
 -->
<template>
  <div v-if="loaded" class="content">
    <paper-info :paper-id="paperId" :paper-info="paperInfo" />
    <search-bar @on-search="clickSearchBtnHandler" @repull-list="repullListHandler" />
    <data-content
      :paper-id="paperId"
      :content-data="contentData"
      @set-order="setOrderHandler"
      @repull-list="repullListHandler"
      @index-change="pageIndexChangedHandler" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import PaperInfo from './components/PaperInfo.vue';
import SearchBar from './components/SearchBar.vue';
import DataContent from './components/DataContent.vue';

let breadcrumb = [
  { text: '统考中心', href: '/tr/portal/index.jsp' },
  { text: '分数统计', href: '/mvc/exam/statistic/query?smId=4006' },
  { text: '考试详情' },
  { text: '试卷详情' },
];

export default {
  name: 'ExamDetail',
  components: {
    PaperInfo,
    SearchBar,
    DataContent,
  },
  props: {
    paperId: { type: [Number, String], required: true },
  },
  data() {
    return {
      loaded: false,
      paperInfo: {
        absenteesNumber: 0,
        examinerNumber: 0,
        name: '',
        passScore: 0,
        status: '',
        totalScore: 0,
      },
      contentData: {
        tableData: [],
        total: 0,
        page: {
          index: 1,
          size: 20,
          count: 0,
        },
      },
      oderBy: null,
    };
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'pageStore/invokeSetBreadcrumb',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setProcessingShowText: 'pageStore/invokeSetProcessingShowText',
    }),
    /**
     * 点击搜索按钮处理函数
     */
    clickSearchBtnHandler(value) {
      this.requestPersonListAndSetting(value);
    },
    /**
     * 分页索引发生改变请求列表
     */
    pageIndexChangedHandler(index) {
      this.contentData.page.index = index;

      this.requestPersonListAndSetting();
    },
    /**
     * 设置排序方式处理函数
     */
    setOrderHandler(order) {
      this.orderBy = order;

      this.requestPersonListAndSetting();
    },
    /**
     * 重新拉取人员列表处理函数
     */
    repullListHandler() {
      this.requestPersonListAndSetting();
    },
    /**
     * 请求参考人员信息列表并设置
     */
    requestPersonListAndSetting(userName) {
      this.requestPersonList(userName)
        .then((result) => {
          /**
             * 后台如果没数据直接不返回字段
             * 做容错
             */
          if (!result.content) {
            result.content = [];
          }

          if (!result.count) {
            result.count = 0;
          }

          if (!result.pageCount) {
            result.pageCount = 0;
          }

          return result;
        })
        .then((result) => {
          this.contentData.tableData = result.content;

          return result;
        })
        .then((result) => {
          this.contentData.total = result.count;

          return result;
        })
        .then((result) => {
          this.contentData.page.index = result.pageIndex;
          this.contentData.page.count = result.pageCount;
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求参考人员信息列表
     */
    requestPersonList(userName) {
      const params = {
        paperId: this.paperId,
        pageNumber: this.contentData.page.index,
        pageSize: this.contentData.page.size,
        orderBy: this.orderBy,
      };

      if (userName) {
        params.userName = userName;
      }

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperPersonList(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 并发请求此页面首屏展示所有数据
     */
    concurrentRquestThisPageData() {
      const infoParams = {
        paperId: this.paperId,
      };

      const listParams = {
        paperId: this.paperId,
        pageNumber: this.contentData.page.index,
        pageSize: this.contentData.page.size,
      };

      axios.all([
        this.$http.examcenter.paperDetailInfo(infoParams),
        this.$http.examcenter.paperPersonList(listParams),
      ])
        .then(axios.spread((paperInfo, personList) => {
          if (paperInfo.code === '200') {
            this.paperInfo = paperInfo.data;
          }

          if (personList.code === '200') {
            /**
             * 后台如果没数据直接不返回字段
             * 做容错
             */
            if (!personList.data.content) {
              personList.data.content = [];
            }

            if (!personList.data.count) {
              personList.data.count = 0;
            }

            if (!personList.data.pageCount) {
              personList.data.pageCount = 0;
            }

            this.contentData.tableData = personList.data.content;

            this.contentData.total = personList.data.count;
            this.contentData.page.index = personList.data.pageIndex;
            this.contentData.page.count = personList.data.pageCount;
          }

          if (!paperInfo.code === '200') {
            alert('数据请求失败');
            this.setProcessingShowState({ show: false });
          } else {
            this.setProcessingShowState({ show: false });
          }

          this.loaded = true;
        }));
    },
    /**
     * 设置面包屑导航路径
     */
    setBreadcrumbHref() {
      const prevUrl = document.referrer;
      const splitUrl = prevUrl.split('/');
      const examId = splitUrl[splitUrl.length - 1];

      breadcrumb = [
        { text: '统考中心', href: '/tr/portal/index.jsp' },
        { text: '分数统计', href: '/mvc/exam/statistic/query?smId=4006' },
        { text: '考试详情', href: `/mvc/exam/statistic/detail/${examId}` },
        { text: '试卷详情' },
      ];

      this.setBreadcrumb({
        breadcrumb,
      });
    },
  },
  created() {
    this.setBreadcrumbHref();

    this.setProcessingShowState({ show: true });

    this.concurrentRquestThisPageData();
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 10px 20px;
  margin-bottom: 0;
}
</style>
